/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	BrandingsUpdatePathParams,
	BrandingsUpdateRequest,
	BrandingsUpdateResponse,
} from '../types/BrandingsUpdate'

/**
 * PUT /brandings/:branding
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::update
 */
export async function brandingsUpdate(
	branding: BrandingsUpdatePathParams['branding'],
	data: BrandingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingsUpdateResponse>> {
	return axiosInstance.put(`/brandings/${branding}`, data, config)
}
